import * as React from "react";
import { SVGProps } from "react";
const SvgLogoGroq = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.53 0A5.482 5.482 0 0 0 2 5.43a5.482 5.482 0 0 0 5.43 5.529h1.9V8.906h-1.8a3.426 3.426 0 0 1-3.466-3.387A3.422 3.422 0 0 1 7.45 2.053h.079a3.44 3.44 0 0 1 3.434 3.424v5.046c0 1.875-1.528 3.403-3.398 3.424a3.385 3.385 0 0 1-2.384-1.003l-1.454 1.454A5.42 5.42 0 0 0 7.53 16h.073a5.481 5.481 0 0 0 5.403-5.456V5.34A5.484 5.484 0 0 0 7.53 0Z"
      fill="#F55036"
    />
  </svg>
);
export default SvgLogoGroq;
